import { __rest } from './external/.pnpm/@rollup_plugin-typescript@11.1.6_rollup@4.9.6_tslib@2.5.3_typescript@4.9.5/external/tslib/tslib.es6.js';
import { createForm as createForm$1 } from '@felte/core';
import { writable } from 'svelte/store';
import { onDestroy } from 'svelte';

function createForm(config) {
    const _a = createForm$1(config !== null && config !== void 0 ? config : {}, {
        storeFactory: writable,
    }), { cleanup, startStores } = _a, rest = __rest(_a, ["cleanup", "startStores"]);
    onDestroy(cleanup);
    return rest;
}

export { createForm };
//# sourceMappingURL=create-form.js.map
